const calendarLocale = {
  weekDays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  months: {
    January: "Jan",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "May",
    June: "Jun",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Dec"
  }
};
export {
  calendarLocale
};
//# sourceMappingURL=en_US.js.map
